import React, { FC, PropsWithChildren } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Button, Caption, CopyText } from '@buderus-apps/components'
import args from 'arguments'
import styles from './styles.module.scss'

const {
  footer,
  'footer__data-privacy': dataPrivacy,
  'footer__info-for-professionals': infoForProfessionals
} = styles

type TProps = PropsWithChildren<{}>

const Footer: FC<TProps> = (props) => {
  const { children } = props

  const { t } = useTranslation()

  const linkToDataPrivacy = args.getArgument('privacyLink')
  const linkToTermsOfUse = args.getArgument('termsOfUseLink')

  return (
    <div className={footer}>
      {children}
      <div className={infoForProfessionals}>
        <Caption>
          <Trans i18nKey={'INFO_FOR_PROFESSIONALS'} />
        </Caption>
      </div>
      <div className={dataPrivacy}>
        <CopyText type='medium-small'>
          {t('AI_HINT')}
        </CopyText>
        <Button
          btnStyle={'link'}
          decoration={'underline'}
          onClick={() => (window.location.href = linkToTermsOfUse)}
        >
          {t('TERMS_OF_USE')}
        </Button>
        <Button
          btnStyle={'link'}
          decoration={'underline'}
          onClick={() => (window.location.href = linkToDataPrivacy)}
        >
          {t('DATA_PRIVACY')}
        </Button>
      </div>
    </div>
  )
}

export default React.memo(Footer)
